// Flameco unified employee auth — DTOs mirror the shipping-app backend.
// See FLAMECO_AUTH_INTEGRATION_GUIDE.html.

export interface SignInRequestDto {
  internalUser: string;
  password: string;
}

export interface SignUpRequestDto {
  internalUser: string;
  password: string;
}

export interface ShippingAppUser {
  id: string;
  internalUser: string;
  role?: string;
  createdAt: string;
  updatedAt: string;
}

export interface AuthResponseDto {
  user: ShippingAppUser;
  token: string;
}

export interface ValidateSessionResponseDto {
  valid: boolean;
  user?: ShippingAppUser;
}

export interface Employee {
  internalId: string;
  name: string;
  jobTitle: string;
  status: string;
  inactive?: boolean;
}

export class ApiException extends Error {
  constructor(public statusCode: number, message: string) {
    super(message);
    this.name = 'ApiException';
  }
}
